import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, CardBody, CardHeader, Col, Placeholder, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faChevronDown, faChevronUp, faStore, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../components/BreadCrumbs';
import { capitalizeFirstLetter, formatTimestamp } from '../../../../utility/Utility';
import { COMPLETED_ORDER_STATUS, CUSTOM_MENU_ITEM_TYPE, ISSUED_BY_KITCHEN_ORDER_STATUS, READY_AT_KITCHEN_ORDER_STATUS } from '../../../../constants/constans';
import { useFindOrderDataByOrderIdMutation } from '../../../../redux/services/orderService';
import { useLocation } from 'react-router-dom';
import { useOrderRefundingMutation } from '../../../../redux/services/orderRefundService';
import './index.css';
import Swal from "sweetalert2";
import { Label } from 'reactstrap';
import StatusBadge from '../../../../components/StatusBatch';
import TableLoadingComponent from '../../../../components/TableLoadingComponent';

export interface Order {
  walletPaymentAmount: any;
  isDirectRestaurantOrder: boolean;
  id: string;
  restaurantId: string;
  address: string;
  paymentMethod: string;
  displayName: string;
  orderStatus: string;
  paymentCompleted: boolean;
  orderItems: OrderItem[];
  orderCreatedBy: string;
  orderReference: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  },
  deliverAt: {
    _seconds: number;
    _nanoseconds: number;
  };

  totalPrice: number;
  cart?: any;
  customer?: any;
  isScheduledOrder: boolean
}
export interface customItems {
  unitPrice: number;
  displayName: string;
  menuItemId: string;
}
export interface OrderItem {
  unitPrice: number;
  itemType: string;
  quantity: number;
  displayName: string;
  menuItemId: string;
  customItems?: customItems[];
  isExpanded?: boolean;
  portionSize?: string
}
const ViewOrderRefund = () => {
  const location = useLocation();
  const order = location.state?.order as any;

  const orderId = order.orderId;
  const refundRequestId = order.id;

  // type ItemType = "MenuItem" | "SetMenu" | "CustomMenu";

  const [orderData, setOrderData] = useState<Order | undefined>(undefined);
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [orderStatus, setOrderStatus] = useState<string>(order.status);

  const toggleRowExpansion = (id: string) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const renderCustomMenuDetails = (item: OrderItem) => {
    if (item.itemType === CUSTOM_MENU_ITEM_TYPE && item?.customItems) {
      return (
        <div className="d-flex justify-content-between">
          { }
          {(item.unitPrice * item.quantity)?.toFixed(2)}

          <Button
            size={"sm"}
            variant="primary"
            onClick={() => toggleRowExpansion(item.menuItemId)}
            aria-expanded={expandedRows[item.menuItemId]}
            aria-controls={`custom-items-${item.menuItemId}`}
          >
            <FontAwesomeIcon
              icon={expandedRows[item.menuItemId] ? faChevronUp : faChevronDown}
            />
          </Button>
        </div>
      );
    }
    return (item.unitPrice * item.quantity)?.toFixed(2);
  };

  const [
    findOrderDataByOrderId,
    { isLoading: isLoadingOrderData },
  ] = useFindOrderDataByOrderIdMutation();

  const fetchOrderData = async () => {
    if (orderId) {
      try {
        const response = await findOrderDataByOrderId(orderId).unwrap();
        if (response) {
          setOrderData(response);
        }
      } catch (error) {
        toast.error("Failed to load order data");
      }
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const expandedRowsRenderer = (row: OrderItem) => {
    if (
      row.itemType === "CustomMenu" &&
      row?.customItems &&
      expandedRows[row.menuItemId]
    ) {
      return row.customItems.map((customItem: any, idx: number) => (
        <tr
          key={`${row.menuItemId}-${idx}`}
          className="custom-item-row-styles"
          style={{ backgroundColor: "grey" }}
        >
          <td>*</td>
          <td>
            <div>&nbsp;&nbsp;&nbsp;{customItem.displayName}</div>
          </td>
          <td>{customItem.unitPrice?.toFixed(2)}</td>
          <td>Extra Item</td>
          <td></td>
          <td></td>
          <td align={"right"}>{customItem.unitPrice?.toFixed(2)}</td>
        </tr>
      ));
    }
    return null;
  };

  useEffect(() => {
    fetchOrderData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const [refundOrder] = useOrderRefundingMutation();

  const handleRefundOrder = async (status: "Completed" | "Rejected") => {
    try {
      const response = await refundOrder({ refundRequestId, status }).unwrap();
      if (response?.status) {
        setOrderStatus(response.status);
        toast.success(
          `Order ${status === "Completed" ? "refunded" : "rejected"} successfully`
        );
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      const errorMessage =
        status === "Completed"
          ? "Failed to refund the order. Please try again."
          : "Failed to reject the order. Please try again.";
      Swal.fire("Error", errorMessage, "error");
    }
  };

  const showRefundModal = (type: "Refund" | "Reject") => {
    const action = type === "Refund" ? "Refund" : "Reject";
    const status = type === "Refund" ? "Completed" : "Rejected";

    Swal.fire({
      title: `Confirm ${action}`,
      text: `Are you sure you want to ${action.toLowerCase()} this order?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${action}!`,
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
    }).then((result) => {
      if (result.isConfirmed) {
        handleRefundOrder(status);
      }
    });
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      {/* {isLoadingOrderData && (
        <div className="loading-overlay">
          <div className="spinner-container">
            <div className="static-spinner"></div>
            <span className="loading-text">Loading...</span>
          </div>
        </div>
      )} */}


      {/* <div className="order-view">
        <div className='d-flex justify-content-left align-items-baseline gap-3'>
          <h4 className="mt-3">Refund order :</h4>
          <StatusBadge status={orderStatus} />
        </div>

        {(orderStatus !== "Completed" && orderStatus !== "Rejected") && (
          <Card style={{ minHeight: "10px" }}>
            <CardBody>
              <Label className="mt-1">Remark</Label>
              <textarea
                placeholder="Add Comment"
                className="w-100 order-refund-text-area p-4"
              />
              <div className="d-flex justify-content-end gap-3 mt-3">
                <Button
                  variant="warning"
                  className="mr-2"
                  onClick={() => showRefundModal("Refund")}
                >
                  Refund
                </Button>
                <Button
                  variant="danger"
                  onClick={() => showRefundModal("Reject")}
                >
                  Reject
                </Button>
              </div>
            </CardBody>
          </Card>
        )}
        <h5 className='mt-5'>Order Details</h5>
        <Row>
          <Col lg="6">
            <Card className="w-100" style={{ height: 340 }}>
              <CardBody>
                <table className="info-table mt-4">
                  <tbody>
                    <tr>
                      <td className="label">
                        {orderData?.orderCreatedBy?.toLowerCase() === "customer"
                          ? "Customer Name"
                          : orderData?.orderCreatedBy?.toLowerCase() ===
                            "cartperson"
                            ? "Cart Name"
                            : orderData?.orderCreatedBy?.toLowerCase() ===
                              "restaurant" && orderData?.customer?.displayName
                              ? "Customer Name"
                              : orderData?.orderCreatedBy?.toLowerCase() ===
                                "restaurant" && orderData?.cart?.displayName
                                ? "Cart Name"
                                : "Loading..."}
                      </td>
                      <td className="value">
                        :{" "}
                        {orderData?.orderCreatedBy?.toLowerCase() ===
                          "customer" && orderData?.customer?.displayName
                          ? orderData?.customer?.displayName
                          : orderData?.orderCreatedBy?.toLowerCase() ===
                            "cartperson" && orderData?.cart?.displayName
                            ? orderData?.cart?.displayName
                            : orderData?.orderCreatedBy?.toLowerCase() ===
                              "restaurant" && orderData?.cart?.displayName
                              ? orderData?.cart?.displayName
                              : orderData?.customer?.displayName ?? "Loading..."}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Order Number</td>
                      <td className="value">: {orderData?.orderReference}</td>
                    </tr>
                    <tr>
                      <td className="label">Status</td>
                      <td className="order-status-style value">
                        :{" "}
                        <Badge
                          color={
                            orderData?.orderStatus === "Pending"
                              ? "warning"
                              : orderData?.orderStatus === "AcceptedByCart"
                                ? "secondary"
                                : orderData?.orderStatus ===
                                  "ApprovedByRestaurant"
                                  ? "info"
                                  : orderData?.orderStatus === "Collecting"
                                    ? "danger"
                                    : orderData?.orderStatus === "Preparing"
                                      ? "primary"
                                      : orderData?.orderStatus === "ReadyAtKitchen"
                                        ? "dark"
                                        : orderData?.orderStatus === "Arrived"
                                          ? "secondary"
                                          : orderData?.orderStatus === "Completed"
                                            ? "success"
                                            : orderData?.orderStatus === "IssuedByKitchen"
                                              ? "dark"
                                              : "secondary"
                          }
                          className="px-3 py-2"
                        >
                          <div style={{ fontSize: 12 }}>
                            {orderData?.orderStatus === "Pending"
                              ? "Pending"
                              : orderData?.orderStatus === "AcceptedByCart"
                                ? "Accepted By Cart"
                                : orderData?.orderStatus ===
                                  "ApprovedByRestaurant"
                                  ? "Approved By Restaurant"
                                  : orderData?.orderStatus === "Collecting"
                                    ? "Collecting"
                                    : orderData?.orderStatus === "Preparing"
                                      ? "Preparing"
                                      : orderData?.orderStatus === "ReadyAtKitchen"
                                        ? "Ready At Kitchen"
                                        : orderData?.orderStatus === "ArrivedAtCart"
                                          ? "Arrived At Cart"
                                          : orderData?.orderStatus ===
                                            COMPLETED_ORDER_STATUS
                                            ? "Completed"
                                            : orderData?.orderStatus === "InAppCart"
                                              ? "In App Cart"
                                              : orderData?.orderStatus ===
                                                ISSUED_BY_KITCHEN_ORDER_STATUS
                                                ? "Issued By Kitchen"
                                                : "Cancelled"}
                          </div>
                        </Badge>
                      </td>
                    </tr>

                    <tr>
                      <td className="label">Created Time</td>
                      <td className="value">
                        : {formatTimestamp(orderData?.createdAt)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Deliver Time</td>
                      <td className="value">
                        : {formatTimestamp(orderData?.deliverAt)}
                        {"  "}
                        {orderData?.isScheduledOrder && (
                          <FontAwesomeIcon
                            className="red-icon-with-space"
                            icon={faCalendarAlt}
                          />
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Order Created By</td>
                      <td className="value">: {orderData?.orderCreatedBy}</td>
                    </tr>
                    <tr>
                      <td className="label">Order Type</td>
                      <td className="value">
                        :{" "}
                        {orderData?.customer ? (
                          <>
                            <FontAwesomeIcon icon={faUserTie} /> &nbsp;Customer
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faStore} /> &nbsp; Cart
                          </>
                        )}
                      </td>
                    </tr>
                    {orderData?.cart && (
                      <tr>
                        <td className="label">Cart</td>
                        <td className="value">
                          {" "}
                          : <FontAwesomeIcon icon={faStore} /> &nbsp;
                          {orderData?.cart?.displayName}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6">
            <Card className="w-100" style={{ height: 340 }}>
              <CardBody>
                <br />
                <div
                  className={
                    orderData &&
                      orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                      ? "info-row"
                      : "info-row-adjust"
                  }
                >
                  <span>Sub Total : </span>
                  <span>
                    LKR{" "}
                    {(orderData &&
                      orderData.isDirectRestaurantOrder === true &&
                      orderData.orderCreatedBy === "CartPerson") ||
                      (orderData?.orderCreatedBy === "Customer" &&
                        orderData?.cart?.cartId)
                      ?
                      orderData?.totalPrice?.toFixed(2)
                      : orderData?.totalPrice?.toFixed(2)}
                  </span>
                </div>
                <div
                  className={
                    orderData &&
                      orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                      ? "info-row"
                      : "info-row-adjust"
                  }
                >
                  <span className="label-value">Payment Method :</span>
                  <span className="t-value">
                    {" "}
                    {orderData
                      ? orderData.paymentMethod === "CashPlusWallet"
                        ? "Cash & Wallet"
                        : orderData.paymentMethod === "CardPlusWallet"
                          ? "Card & Wallet"
                          : orderData.paymentMethod
                      : ""}
                  </span>
                </div>
                <div
                  className={
                    orderData &&
                      orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                      ? "info-row"
                      : "info-row-adjust"
                  }
                >
                  <span className="label-value">Paid by wallet :</span>
                  <span className="t-value">
                    LKR{" "}
                    {orderData && orderData.walletPaymentAmount?.toFixed(2)}
                  </span>
                </div>
                <div
                  className={
                    orderData &&
                      orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                      ? "info-row"
                      : "info-row-adjust"
                  }
                >
                  <span className="label-value">Paid by Card :</span>
                  <span className="t-value">
                    LKR{" "}
                    {orderData && orderData.paymentCompleted
                      ? (
                        orderData.totalPrice - orderData.walletPaymentAmount
                      )?.toFixed(2)
                      : "0.00"}
                  </span>
                </div>
                <div
                  className={
                    orderData &&
                      orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                      ? "info-row"
                      : "info-row-adjust"
                  }
                >
                  <span className="label-value">Cart commission :</span>
                  <span className="t-value">
                    LKR{" "}
                    {(orderData &&
                      orderData.isDirectRestaurantOrder === true &&
                      orderData.orderCreatedBy === "CartPerson") ||
                      (orderData?.orderCreatedBy === "Restaurant" &&
                        orderData?.cart?.cartId) ||
                      (orderData?.orderCreatedBy === "Customer" &&
                        orderData?.cart?.cartId)
                      ?
                      (orderData?.totalPrice * (5 / 100)).toFixed(2)
                      : "0.00"}
                  </span>
                </div>
                <hr />
                <div
                  className={
                    orderData &&
                      orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                      ? "info-row"
                      : "info-row-adjust"
                  }
                >
                  <h5 className="label-value">Need to Pay :</h5>
                  <h5 className="t-value text-danger">
                    LKR{" "}
                    {orderData
                      ? Math.max(
                        (orderData.isDirectRestaurantOrder === true &&
                          orderData.orderCreatedBy === "CartPerson") ||
                          (orderData.orderCreatedBy === "Restaurant" &&
                            orderData.cart?.cartId) ||
                          (orderData.orderCreatedBy === "Customer" &&
                            orderData.cart?.cartId)
                          ? orderData.totalPrice -
                          (orderData.paymentCompleted
                            ? orderData.totalPrice -
                            orderData.walletPaymentAmount || 0
                            : 0) -
                          (orderData.walletPaymentAmount || 0) -
                          orderData.totalPrice * (5 / 100)
                          : orderData.totalPrice -
                          (orderData.paymentCompleted
                            ? orderData.totalPrice -
                            orderData.walletPaymentAmount || 0
                            : 0) -
                          (orderData.walletPaymentAmount || 0),
                        0
                      ).toFixed(2)
                      : "0.00"}
                  </h5>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Card className="order-card">
          <CardHeader className="order-card-header">
            <h6>Order Items</h6>
          </CardHeader>
          <CardBody>
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item Name</th>
                  <th>Per Item Price (LKR)</th>
                  <th>Item Type</th>
                  <th>Portion Size</th>
                  <th>Quantity</th>
                  <th>Total (LKR)</th>
                </tr>
              </thead>
              <tbody>
                {orderData &&
                  [...orderData.orderItems]
                    .sort((a: OrderItem, b: OrderItem) => {
                      const orderPriority: { [key in ItemType]: number } = {
                        MenuItem: 1,
                        SetMenu: 2,
                        CustomMenu: 3,
                      };
                      return (
                        orderPriority[a.itemType as ItemType] -
                        orderPriority[b.itemType as ItemType]
                      );
                    })
                    .map((item: OrderItem, index: number) => (
                      <React.Fragment key={item.menuItemId}>
                        <tr className="custom-item-row border-none">
                          <td>{index + 1} .</td>
                          <td>{item.displayName}</td>
                          <td>{item.unitPrice?.toFixed(2)}</td>
                          <td>
                            {item.itemType.replace(/([a-z])([A-Z])/g, "$1 $2")}
                          </td>
                          <td>
                            {item.portionSize
                              ? capitalizeFirstLetter(item.portionSize)
                              : " "}
                          </td>
                          <td>{item.quantity}</td>
                          <td>{renderCustomMenuDetails(item)}</td>
                        </tr>
                        {expandedRowsRenderer(item)}
                      </React.Fragment>
                    ))}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </div> */}
      {isLoadingOrderData ? (
        <>
          <h5 className='mt-5'>Order Details</h5>
          <Row>
            <Col lg="6">
              <Card className="w-100" style={{ height: 340 }}>
                <CardBody>
                  <table className="info-table mt-4">
                    <tbody>
                      <tr>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card className="w-100" style={{ height: 340 }}>
                <CardBody>
                  <table className="info-table mt-4">
                    <tbody>
                      <tr>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                      <tr className='mt-5 mb-5'>
                        <td className='value'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                        <td className='label'>
                          <Placeholder animation='wave'>
                            <Placeholder xs={12} />
                          </Placeholder>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Card className="order-card">
            <TableLoadingComponent numColumns={5} />
          </Card>
        </>
      ) : (
        <div className="order-view">
          <div className='d-flex justify-content-left align-items-baseline gap-3'>
            <h4 className="mt-3">Refund order :</h4>
            <StatusBadge status={orderStatus} />
          </div>

          {orderStatus !== "Completed" && orderStatus !== "Rejected" && (
            <Card style={{ minHeight: "10px" }}>
              <CardBody>
                <Label className="mt-1">Remark</Label>
                <textarea
                  placeholder="Add Comment"
                  className="w-100 order-refund-text-area p-4"
                />
                <div className="d-flex justify-content-end gap-3 mt-3">
                  <Button variant="warning" className="mr-2" onClick={() => showRefundModal("Refund")}>
                    Refund
                  </Button>
                  <Button variant="danger" onClick={() => showRefundModal("Reject")}>
                    Reject
                  </Button>
                </div>
              </CardBody>
            </Card>
          )}

          <h5 className='mt-5'>Order Details</h5>
          <Row>
            <Col lg="6">
              <Card className="w-100" style={{ height: 340 }}>
                <CardBody>
                  <table className="info-table mt-4">
                    <tbody>
                      <tr>
                      <td className="label">
                        {orderData?.orderCreatedBy?.toLowerCase() === "customer"
                          ? "Customer Name"
                          : orderData?.orderCreatedBy?.toLowerCase() ===
                            "cartperson"
                            ? "Cart Name"
                            : orderData?.orderCreatedBy?.toLowerCase() ===
                              "restaurant" && orderData?.customer?.displayName
                              ? "Customer Name"
                              : orderData?.orderCreatedBy?.toLowerCase() ===
                                "restaurant" && orderData?.cart?.displayName
                                ? "Cart Name"
                                : "Loading..."}
                      </td>
                      <td className="value">
                        :{" "}
                        {orderData?.orderCreatedBy?.toLowerCase() ===
                          "customer" && orderData?.customer?.displayName
                          ? orderData?.customer?.displayName
                          : orderData?.orderCreatedBy?.toLowerCase() ===
                            "cartperson" && orderData?.cart?.displayName
                            ? orderData?.cart?.displayName
                            : orderData?.orderCreatedBy?.toLowerCase() ===
                              "restaurant" && orderData?.cart?.displayName
                              ? orderData?.cart?.displayName
                              : orderData?.customer?.displayName ?? "Loading..."}
                      </td>
                      </tr>
                      <tr>
                        <td className="label">Order Number</td>
                        <td className="value">: {orderData?.orderReference}</td>
                      </tr>
                      <tr>
                        <td className="label">Status</td>
                        <td className="order-status-style value">
                          :{" "}
                          <Badge
                            color={
                              orderData?.orderStatus === "Pending"
                                ? "warning"
                                : orderData?.orderStatus === "AcceptedByCart"
                                  ? "secondary"
                                  : orderData?.orderStatus ===
                                    "ApprovedByRestaurant"
                                    ? "info"
                                    : orderData?.orderStatus === "Collecting"
                                      ? "danger"
                                      : orderData?.orderStatus === "Preparing"
                                        ? "primary"
                                        : orderData?.orderStatus === "ReadyAtKitchen"
                                          ? "dark"
                                          : orderData?.orderStatus === "Arrived"
                                            ? "secondary"
                                            : orderData?.orderStatus === "Completed"
                                              ? "success"
                                              : orderData?.orderStatus === "IssuedByKitchen"
                                                ? "dark"
                                                : "secondary"
                            }
                            className="px-3 py-2"
                          >
                            <div style={{ fontSize: 12 }}>
                              {orderData?.orderStatus === "Pending"
                                ? "Pending"
                                : orderData?.orderStatus === "AcceptedByCart"
                                  ? "Accepted By Cart"
                                  : orderData?.orderStatus ===
                                    "ApprovedByRestaurant"
                                    ? "Approved By Restaurant"
                                    : orderData?.orderStatus === "Collecting"
                                      ? "Collecting"
                                      : orderData?.orderStatus === "Preparing"
                                        ? "Preparing"
                                        : orderData?.orderStatus === "ReadyAtKitchen"
                                          ? "Ready At Kitchen"
                                          : orderData?.orderStatus === "ArrivedAtCart"
                                            ? "Arrived At Cart"
                                            : orderData?.orderStatus ===
                                              COMPLETED_ORDER_STATUS
                                              ? "Completed"
                                              : orderData?.orderStatus === "InAppCart"
                                                ? "In App Cart"
                                                : orderData?.orderStatus ===
                                                  ISSUED_BY_KITCHEN_ORDER_STATUS
                                                  ? "Issued By Kitchen"
                                                  : "Cancelled"}
                            </div>
                          </Badge>
                        </td>
                      </tr>
                      <tr>
                        <td className="label">Created Time</td>
                        <td className="value">: {formatTimestamp(orderData?.createdAt)}</td>
                      </tr>
                      <tr>
                        <td className="label">Deliver Time</td>
                        <td className="value">
                          : {formatTimestamp(orderData?.deliverAt)}
                          {orderData?.isScheduledOrder && <FontAwesomeIcon className="red-icon-with-space" icon={faCalendarAlt} />}
                        </td>
                      </tr>
                      <tr>
                        <td className="label">Order Created By</td>
                        <td className="value">: {orderData?.orderCreatedBy}</td>
                      </tr>
                      <tr>
                      <td className="label">Order Type</td>
                      <td className="value">
                        :{" "}
                        {orderData?.customer ? (
                          <>
                            <FontAwesomeIcon icon={faUserTie} /> &nbsp;Customer
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faStore} /> &nbsp; Cart
                          </>
                        )}
                      </td>
                    </tr>
                    {orderData?.cart && (
                      <tr>
                        <td className="label">Cart</td>
                        <td className="value">
                          {" "}
                          : <FontAwesomeIcon icon={faStore} /> &nbsp;
                          {orderData?.cart?.displayName}
                        </td>
                      </tr>
                    )}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card className="w-100" style={{ height: 340 }}>
                <CardBody>
                  <br />
                  <div
                    className={
                      orderData &&
                        orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                        ? "info-row"
                        : "info-row-adjust"
                    }
                  >
                    <span>Sub Total : </span>
                    <span>
                      LKR{" "}
                      {(orderData &&
                        orderData.isDirectRestaurantOrder === true &&
                        orderData.orderCreatedBy === "CartPerson") ||
                        (orderData?.orderCreatedBy === "Customer" &&
                          orderData?.cart?.cartId)
                        ?
                        orderData?.totalPrice?.toFixed(2)
                        : orderData?.totalPrice?.toFixed(2)}
                    </span>
                  </div>
                  <div
                    className={
                      orderData &&
                        orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                        ? "info-row"
                        : "info-row-adjust"
                    }
                  >
                    <span className="label-value">Payment Method :</span>
                    <span className="t-value">
                      {" "}
                      {orderData
                        ? orderData.paymentMethod === "CashPlusWallet"
                          ? "Cash & Wallet"
                          : orderData.paymentMethod === "CardPlusWallet"
                            ? "Card & Wallet"
                            : orderData.paymentMethod
                        : ""}
                    </span>
                  </div>
                  <div
                    className={
                      orderData &&
                        orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                        ? "info-row"
                        : "info-row-adjust"
                    }
                  >
                    <span className="label-value">Paid by wallet :</span>
                    <span className="t-value">
                      LKR{" "}
                      {orderData && orderData.walletPaymentAmount?.toFixed(2)}
                    </span>
                  </div>
                  <div
                    className={
                      orderData &&
                        orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                        ? "info-row"
                        : "info-row-adjust"
                    }
                  >
                    <span className="label-value">Paid by Card :</span>
                    <span className="t-value">
                      LKR{" "}
                      {orderData && orderData.paymentCompleted
                        ? (
                          orderData.totalPrice - orderData.walletPaymentAmount
                        )?.toFixed(2)
                        : "0.00"}
                    </span>
                  </div>
                  <div
                    className={
                      orderData &&
                        orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                        ? "info-row"
                        : "info-row-adjust"
                    }
                  >
                    <span className="label-value">Cart commission :</span>
                    <span className="t-value">
                      LKR{" "}
                      {(orderData &&
                        orderData.isDirectRestaurantOrder === true &&
                        orderData.orderCreatedBy === "CartPerson") ||
                        (orderData?.orderCreatedBy === "Restaurant" &&
                          orderData?.cart?.cartId) ||
                        (orderData?.orderCreatedBy === "Customer" &&
                          orderData?.cart?.cartId)
                        ?
                        (orderData?.totalPrice * (5 / 100)).toFixed(2)
                        : "0.00"}
                    </span>
                  </div>
                  <hr />
                  <div
                    className={
                      orderData &&
                        orderData.orderStatus === READY_AT_KITCHEN_ORDER_STATUS
                        ? "info-row"
                        : "info-row-adjust"
                    }
                  >
                    <h5 className="label-value">Need to Pay :</h5>
                    <h5 className="t-value text-danger">
                      LKR{" "}
                      {orderData
                        ? Math.max(
                          (orderData.isDirectRestaurantOrder === true &&
                            orderData.orderCreatedBy === "CartPerson") ||
                            (orderData.orderCreatedBy === "Restaurant" &&
                              orderData.cart?.cartId) ||
                            (orderData.orderCreatedBy === "Customer" &&
                              orderData.cart?.cartId)
                            ? orderData.totalPrice -
                            (orderData.paymentCompleted
                              ? orderData.totalPrice -
                              orderData.walletPaymentAmount || 0
                              : 0) -
                            (orderData.walletPaymentAmount || 0) -
                            orderData.totalPrice * (5 / 100)
                            : orderData.totalPrice -
                            (orderData.paymentCompleted
                              ? orderData.totalPrice -
                              orderData.walletPaymentAmount || 0
                              : 0) -
                            (orderData.walletPaymentAmount || 0),
                          0
                        ).toFixed(2)
                        : "0.00"}
                    </h5>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card className="order-card">
            <CardHeader className="order-card-header">
              <h6>Order Items</h6>
            </CardHeader>
            <CardBody>
              <table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Item Name</th>
                    <th>Per Item Price (LKR)</th>
                    <th>Item Type</th>
                    <th>Portion Size</th>
                    <th>Quantity</th>
                    <th>Total (LKR)</th>
                  </tr>
                </thead>
                <tbody>
                  {orderData?.orderItems?.map((item, index) => (
                    <tr key={item.menuItemId} className="custom-item-row border-none">
                      <td>{index + 1} .</td>
                      <td>{item.displayName}</td>
                      <td>{item.unitPrice?.toFixed(2)}</td>
                      <td>
                        {item.itemType.replace(/([a-z])([A-Z])/g, "$1 $2")}
                      </td>
                      <td>{item.portionSize ? capitalizeFirstLetter(item.portionSize) : " "}</td>
                      <td>{item.quantity}</td>
                      <td>{renderCustomMenuDetails(item)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
      )}
    </>
  )
}

export default ViewOrderRefund;